// 匿名登入 不登入
export const ANONYMOUS_LOGIN = 0;
// Facebook 登入
export const FACEBOOK_LOGIN = 1;
// Line 登入
export const LINE_LOGIN = 2;
// 企業登入
export const ENTERPRISE_LOGIN = 3;
